import { useState, useEffect } from "react";
import { getHostname } from '@/lib/util';
import { ElementProps } from '@/types/elements';
import clsx from 'clsx';
import { ArrowUpRight } from 'react-feather';



export default function LinkCardElement({ block: { id: blockId, data }, viewMode, tracer, appearance }: ElementProps) {
    const { title, cover, link, description } = data;
    const [imgError, setImgError] = useState(false)
    return (
        <div className="relative transition duration-500 hover:scale-105">
            <div onClick={() => tracer?.openLink({ blockId, link, meta: {} })}>
                <div
                    className={clsx(viewMode ? "md:p-3" : "", appearance?.corner === 'square' ? 'rounded-none' : 'rounded-lg', "flex border p-2.5 h-32 post-items bg-white border-gray-300 link-card cursor-pointer hover:cursor-pointer hover:drop-shadow-xl")}>
                    <div className={clsx("relative flex-none w-28", viewMode ? "md:w-44" : "")}>
                        {
                            cover !== "" && !imgError && <img src={cover} alt="logo"
                                onError={() => setImgError(true)}
                                className={clsx(appearance?.corner === 'square' ? 'rounded-none' : 'rounded-lg', "absolute inset-0 object-cover w-full h-full")} />
                        }
                        {
                            (cover === "" || imgError) && <div className={clsx(appearance?.corner === 'square' ? 'rounded-none' : 'rounded-lg', "absolute inset-0 flex items-center justify-center object-cover w-full h-full text-2xl bg-gray-100")}>
                                📄
                            </div>
                        }
                    </div>
                    <div className="content-center mt-1 ml-3 mr-8"><span
                        className={clsx("block text-sm font-medium leading-tight text-gray-800 link-title", viewMode ? "md:text-md" : "")}>{title}</span>
                        <span className="text-xs text-gray-600"> {getHostname(link)} </span>
                        <p className={clsx("hidden py-2 text-sm text-gray-600 subtitle", viewMode ? "md:flexx xline-clamp-1" : "")}>{description}</p>
                    </div>
                </div>
                <span className="absolute bottom-0 right-0 pb-2 pr-2 text-gray-500">
                    <img src={`https://www.google.com/s2/favicons?sz=32&domain_url=${getHostname(link)}`} className="w-6 h-6 rounded-full" alt={getHostname(link)} />
                </span>
                <span className="absolute top-0 right-0 pt-2 pr-2 text-gray-500">
                    <ArrowUpRight width={24} height={24} className="stroke-gray-500" />
                </span>
            </div>

            <style jsx global>{`
                    .link-card:hover {
                        border-color: ${appearance?.buttonBackgroundColor};
                    }
                    .link-title {
                       overflow: hidden;
                       text-overflow: ellipsis;
                       display: -webkit-box;
                       -webkit-line-clamp: 4;
                       -webkit-box-orient: vertical;
                    }
          `}</style>
        </div>
    )
}
